import moment from 'moment';
import db from '../../config/databases/forms';
// import dispatchAlert from '../Alert/dispatchAlert';
import getFormLocal from './getFormLocal';
import updateFormStatus from './updateFormStatus';
import { LOCALSTATUS as localStatusList, STATUS as statusList } from '../../config';

import postFormError from '../Error/postErrorForm';
import ApiService from '../api/ApiService';

const transformRequest = (jsonData = {}) =>
  Object.entries(jsonData)
    .map((x) => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
    .join('&');

// Write the forms file and trigger the event
export default async function postForm(formId, status = statusList.in_progress, onlyStatus = false) {
  let data = {};
  let form = {};
  data.status = status;
  if (!onlyStatus) {
    form = await getFormLocal(formId);
    data.inspection = JSON.stringify(form.inspection);
  }
  data = transformRequest(data);
  try {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    const response = await ApiService('postForm', { formId }, null, data, headers, 'form-urlencoded');

    if (response.status > 299) throw new Error('API_POST_FORM_FAILED');
  } catch (error) {
    if (error.toString().includes('Network Error')) {
      await updateFormStatus(formId, localStatusList.error_network, 'localStatus');
    } else {
      await updateFormStatus(formId, localStatusList.error_post_form, 'localStatus');
      postFormError(form);
      // dispatchAlert('form_post_error', 'warning', 'form_post_error');
    }
    return false;
  }

  await updateFormStatus(formId, status);
  await updateFormStatus(formId, localStatusList.synchronized, 'localStatus');
  await db.forms.update(parseInt(formId, 10), { updatedAt: moment().format() });

  return true;
}
